import { NgModule } from '@angular/core';
import { KnBrCartBaseComponentsModule } from './components/kn-br-cart-base-components.module';
import { KnBrCartBaseOccModule } from './occ/kn-br-cart-base-occ.module';
import { CartBaseCoreModule } from '@spartacus/cart/base/core';
import { provideConfig, I18nConfig } from '@spartacus/core';
import { KnBrCartBaseTranslationChunksConfig, KnBrCartBaseTranslations } from './assets/translations/translation';

@NgModule({
  imports: [KnBrCartBaseComponentsModule, KnBrCartBaseOccModule, CartBaseCoreModule]
})
export class KnBrCartBaseModule { }
